<template>
  <div>
    <b-form-group>
      <b-form-checkbox v-model="formData.periodicGeneration">Okresowe generowanie raportu</b-form-checkbox>
    </b-form-group>
    <b-form-row>
      <small class="text-danger col-sm-7 offset-sm-5" v-show="formData.periodicGeneration && dataErrors.date">Należy podać datę.</small>
    </b-form-row>
    <b-form-group label="Data" horizontal label-cols="5" v-show="formData.periodicGeneration">
      <el-date-picker v-model="formData.date"
        :class="{'is-invalid': dataErrors.date}"
        type="date"
        format="dd-MM-yyyy"
        class="w-100"
        placeholder="Data">
      </el-date-picker>
    </b-form-group>
    <b-form-row>
      <small class="text-danger col-sm-7 offset-sm-5" v-show="formData.periodicGeneration && dataErrors.time">Należy podać czas.</small>
    </b-form-row>
    <b-form-group label="Czas" horizontal label-cols="5" v-show="formData.periodicGeneration">
      <el-time-select class="w-100"
        placeholder="Czas" 
        :class="{'is-invalid': dataErrors.time}"
        v-model="formData.time"
        :picker-options="{start: '00:00', end: '23:59', step: '00:15'}">
      </el-time-select>
    </b-form-group>
    <b-form-row>
      <small class="text-danger col-sm-7 offset-sm-5" v-show="formData.periodicGeneration && dataErrors.frequency">Należy wybrać cykliczność.</small>
    </b-form-row>
    <b-form-group label="Cykliczność" horizontal label-cols="5" v-show="formData.periodicGeneration">
      <b-form-select :options="frequenciesList" v-model="formData.frequency" :class="{'is-invalid': dataErrors.frequency}"></b-form-select>
    </b-form-group>
    <b-form-row>
      <small class="text-danger col-sm-7 offset-sm-5" v-show="formData.periodicGeneration && dataErrors.repeats">Należy podać liczbę powtórzeń.</small>
    </b-form-row>
    <b-form-group label="Liczba powtórzeń" horizontal label-cols="5" v-show="formData.periodicGeneration">
      <input-number
        v-model="formData.repeats"
        placeholder="Liczba powtórzeń"
        integer
        :class="{'form-control': true, 'text-right': true, 'is-invalid': dataErrors.repeats}">
      </input-number>
    </b-form-group>
    <b-form-group label="Adres e-mail" horizontal label-cols="5" v-show="formData.periodicGeneration">
      <span class="mb-1">{{contextEmail}}</span>
      <b-form-textarea v-model="formData.email" :class="{'is-invalid': dataErrors.email}" placeholder="Wpisz adresy e-mail oddzielone średnikami"></b-form-textarea>
      <small class="text-muted">Adresy email muszą być oddzielone średnikami.</small>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

import InputNumber from '../InputNumber';

export default {
  name: "ReportwizardPeriodicGeneration",
  components:{
    InputNumber
  },
  data: function() {
    return {
      dataErrors: {
        date: false,
        time: false,
        frequency: false,
        repeats: false
      },
      frequenciesList: [
        { text: "Wybierz", value: "", disabled: true },
        { text: "Co dzień", value: "day" },
        { text: "Co tydzień", value: "week" },
        { text: "Co miesiąc", value: "month" },
        { text: "Co rok", value: "year" }
      ]
    };
  },
  props: {
    formData: Object
  },
  computed: {
    dateTime() {
      return moment(
        moment(this.formData.date).format("DD-MM-YYYY") + " " + this.formData.time,
        "DD-MM-YYYY HH:mm"
      ).format("X");
    }
  },
  methods: {
    validateNumber(number) {
      number = (number || '').toString();

      if (!number) {
        return true;
      }

      return /^(10000(,[0]{1,2})?|([0-9]{1,4}(,[0-9]{1,2})?))$/.test(number);
    },
    validate() {
      const self = this;

      self.dataErrors.date = self.formData.periodicGeneration && !self.formData.date;
      self.dataErrors.time = self.formData.periodicGeneration && !self.formData.time;
      self.dataErrors.frequency = self.formData.periodicGeneration && !self.formData.frequency;
      self.dataErrors.repeats = self.formData.periodicGeneration && !self.formData.repeats;

      return !Object.keys(self.dataErrors).some(x => self.dataErrors[x]);
    },
    reset() {
      const self = this;

      self.formData.periodicGeneration = false;
      self.formData.date = undefined;
      self.formData.time = undefined;
      self.formData.frequency = "";
      self.formData.repeats = undefined;
      self.formData.email = undefined;

      Object.keys(self.dataErrors).forEach(x => (self.dataErrors[x] = false));
    }
  }
};
</script>

<style>
.is-invalid input,
.is-invalid input:focus,
.is-invalid input:hover {
  border-color: #e40909;
}
</style>
